import { UPDATE_CLIENT_BALANCE } from "../constants/reduxConstants";

  
  const BalanceReducer = (
    state = {
      clientBalance: "0.00",
    },
    action
  ) => {
    switch (action.type) {
      case UPDATE_CLIENT_BALANCE:
        return {
          ...state,
          clientBalance: action.data?.availableBalance,
        };
      default:
        return state;
    }
  };
  
  export default BalanceReducer;
  